define('SignaturePad', [], function () {
    'use strict';

    function SignaturePad(canvasElement, options) {
        options = options || {};
        this.canvas = canvasElement;
        this.ctx = this.canvas.getContext('2d');
        this.penColor = options.penColor || '#003366';
        this.lineWidth = options.lineWidth || 2.5;
        this.backgroundColor = options.backgroundColor || '#ffffff';
        this._isDrawing = false;
        this._hasDrawn = false;
        this._lastX = 0;
        this._lastY = 0;

        this.init();
    }

    SignaturePad.prototype.init = function () {
        var self = this;
        
        // Prevent default touch behaviors like scrolling while signing
        this.canvas.style.touchAction = 'none';
        this.canvas.style.userSelect = 'none';
        
        this.resizeCanvas();

        // Mouse Events
        this.canvas.addEventListener('mousedown', function (e) {
            self._startStroke(self._getCanvasCoords(e));
        });

        this.canvas.addEventListener('mousemove', function (e) {
            if (self._isDrawing) {
                self._drawStroke(self._getCanvasCoords(e));
            }
        });

        window.addEventListener('mouseup', function () {
            self._endStroke();
        });

        // Touch Events
        this.canvas.addEventListener('touchstart', function (e) {
            e.preventDefault();
            if (e.touches && e.touches.length > 0) {
                self._startStroke(self._getCanvasCoords(e.touches[0]));
            }
        }, { passive: false });

        this.canvas.addEventListener('touchmove', function (e) {
            e.preventDefault();
            if (self._isDrawing && e.touches && e.touches.length > 0) {
                self._drawStroke(self._getCanvasCoords(e.touches[0]));
            }
        }, { passive: false });

        this.canvas.addEventListener('touchend', function (e) {
            self._endStroke();
        });

        this.canvas.addEventListener('touchcancel', function () {
            self._endStroke();
        });
    };

    SignaturePad.prototype._getCanvasCoords = function (event) {
        var rect = this.canvas.getBoundingClientRect();
        var scaleX = this.canvas.width / rect.width;
        var scaleY = this.canvas.height / rect.height;

        return {
            x: (event.clientX - rect.left) * scaleX,
            y: (event.clientY - rect.top) * scaleY
        };
    };

    SignaturePad.prototype._startStroke = function (point) {
        this._isDrawing = true;
        this._lastX = point.x;
        this._lastY = point.y;
        
        this.ctx.beginPath();
        this.ctx.strokeStyle = this.penColor;
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.lineCap = 'round';
        this.ctx.lineJoin = 'round';
        this.ctx.moveTo(point.x, point.y);
    };

    SignaturePad.prototype._drawStroke = function (point) {
        if (!this._isDrawing) return;

        this.ctx.beginPath();
        this.ctx.moveTo(this._lastX, this._lastY);
        this.ctx.lineTo(point.x, point.y);
        this.ctx.stroke();

        this._lastX = point.x;
        this._lastY = point.y;
        this._hasDrawn = true;
    };

    SignaturePad.prototype._endStroke = function () {
        if (this._isDrawing) {
            this._isDrawing = false;
        }
    };

    SignaturePad.prototype.resizeCanvas = function () {
        var ratio = Math.max(window.devicePixelRatio || 1, 1);
        var rect = this.canvas.getBoundingClientRect();
        var displayWidth = rect.width || 310;
        var displayHeight = rect.height || 180;

        // Store existing drawing content before resize if canvas had content
        var existingData = null;
        if (this._hasDrawn && this.canvas.width > 0 && this.canvas.height > 0) {
            existingData = this.canvas.toDataURL();
        }

        this.canvas.width = displayWidth * ratio;
        this.canvas.height = displayHeight * ratio;
        this.ctx.scale(ratio, ratio);

        this.clear();

        if (existingData) {
            var img = new Image();
            var self = this;
            img.onload = function () {
                self.ctx.drawImage(img, 0, 0, displayWidth, displayHeight);
                self._hasDrawn = true;
            };
            img.src = existingData;
        }
    };

    SignaturePad.prototype.clear = function () {
        var rect = this.canvas.getBoundingClientRect();
        var width = rect.width || 310;
        var height = rect.height || 180;

        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.fillStyle = this.backgroundColor;
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.restore();

        this._hasDrawn = false;
        this._isDrawing = false;
    };

    SignaturePad.prototype.isEmpty = function () {
        return !this._hasDrawn;
    };

    SignaturePad.prototype.toDataURL = function (type) {
        if (this.isEmpty()) {
            return '';
        }
        return this.canvas.toDataURL(type || 'image/png');
    };

    return SignaturePad;
});
